var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#1d1d1d",
    stroke: "#1d1d1d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:1.91px;}")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.3,
    y: 18.68,
    width: 5.73,
    height: 3.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.48,
    y: 14.86,
    width: 5.73,
    height: 3.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.34,
    y: 11.05,
    width: 5.73,
    height: 3.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.2,
    y: 14.86,
    width: 5.73,
    height: 3.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.93,
    y: 14.86,
    width: 5.73,
    height: 3.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.02,
    y: 18.68,
    width: 5.73,
    height: 3.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.75,
    y: 18.68,
    width: 5.73,
    height: 3.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.61,10.09l-4.14,1.66a1,1,0,0,1-1.11-.23h0a1,1,0,0,1-.22-1.1L15.8,6.27h0a3.82,3.82,0,0,1,3.81,3.82Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "18.66 7.23 19.61 6.27 19.61 3.41 22.48 1.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.3,
    y1: 22.5,
    x2: 0.52,
    y2: 22.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/Build.6ecc897a1db710af7b4c922f9bc969fa.svg";
export { ForwardRef as ReactComponent };